import React from "react";
import "./Services.css";

const Services = () => {
  return (
    <div id="servicesComp" className="services">
      <div className="servicesImg"></div>

      <div className="servicesInfo1">
        <div className="service1">
          <img
            id="serviceIcon"
            src={require("../../assets/analysis.png")}
            alt="Description"
          />
          <h2 className="serviceHeading">Strategy</h2>
          <p className="serviceDis">Develop a tailored workout plan targeting specific fitness goals with a perfect strategy</p>
        </div>
        <div className="service2">
          <img
            id="serviceIcon"
            src={require("../../assets/weightlifting.png")}
            alt="Description"
          />
          <h2 className="serviceHeading">Weight Training</h2>
          <p className="serviceDis">Weight training enhances strength, builds muscle mass, and boosts metabolism.</p>
        </div>
      </div>

      <div className="servicesInfo2">
        <div className="service1">
          <img
            id="serviceIcon"
            src={require("../../assets/yoga.png")}
            alt="Description"
          />
          <h2 className="serviceHeading">Yoga</h2>
          <p className="serviceDis">Yoga fosters holistic well-being, emphasizing mental & physical balance by mindful poses and breathwork.</p>
        </div>
        <div className="service2">
          <img
            id="serviceIcon"
            src={require("../../assets/weight-loss.png")}
            alt="Description"
          />
          <h2 className="serviceHeading">Weight loss</h2>
          <p className="serviceDis">Get personalized training for your fitness and weight goals through proper diet and workout.</p>
        </div>
      </div>
    </div>
  );
};

export default Services;
